import { Component, Plugin } from 'vue';

interface ComponentEntries {
	[key: string]: Component;
}

/**
 * Adds components in `@/components/base` to global app scope
 */
export const globalComponentsPlugin =
	(globalComponents: ComponentEntries[]): Plugin =>
	app => {
		for (const components of globalComponents) {
			Object.keys(components).forEach(key => {
				// Register with original name (BaseButton)
				app.component(key, components[key]);
				// Also register with kebab-case (base-button)
				const kebabKey = key
					.replace(/([A-Z])/g, '-$1')
					.toLowerCase()
					.replace(/^-/, '');
				app.component(kebabKey, components[key]);
			});
		}
	};
